const definedCurrencySymbol = {
  US_Dollar: '$ ',
};
const getCurrency = (currencyString, currencyAmount) => {
  let foundSymbol = currencyString ? definedCurrencySymbol[currencyString] : null;
  foundSymbol = foundSymbol || '$ ';
  return (
    foundSymbol +
    Number(currencyAmount)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  );
};

const getNumber = formattedCurrency => {
  return formattedCurrency.replace(/[^0-9.]/g, '');
};

export { getCurrency, getNumber };
